export default "__VITE_ASSET__DSIkjMO0__"